export default {"src":"/_next/static/media/drip-studio.96484029.svg","height":606,"width":982};